<template>
    <div class="configuration">
        <h1>設定</h1>
        <el-card>
            <div slot="header" class="clearfix">
                <span>カメラ一覧</span>
            </div>
            <ul>
                <li v-for="camera in cameras.dataset" :key="camera.camera_name" class="density">
                    <div class="stream-name">{{camera.camera_name}}</div>
                    <UpdateConfiguration :streamData="camera" />
                </li>
            </ul>
            <div class="update-configuration-button">
                <el-button type="primary" @click="updateThreshold" 
                    v-loading.fullscreen.lock="fullscreenLoading"
                    element-loading-text="設定人数を更新中です。少々お待ちください。"
                    element-loading-spinner="el-icon-loading" 
                    element-loading-background="rgba(0,0,0,0.7)">更新</el-button>
            </div>
        </el-card>
            
    </div>
</template>

<script>
import UpdateConfiguration from '@/components/option/UpdateConfiguration.vue';

export default {
    data() {
        return {
            errorMsg: '',
            fullscreenLoading: false
        }
    },
    components: {
        UpdateConfiguration,
    },
    computed: {
        cameras() {
            return this.$store.state.dailyData
        },
        isComplete() {
            return this.$store.getters.isCompleteUpdate
        }
    },
    methods: {
        updateThreshold: async function(){
            // DynamoDBのデータを更新
            try{
                this.fullscreenLoading = true
                await this.$store.dispatch('updateOption')
                setTimeout(() => {
                    // 設定人数更新完了するまで、リクエスト送信
                    this.runAgain();
                }, 1000);
            }catch(e){
                this.$message.error(e.message)
                this.fullscreenLoading = false
            }
        },

        runAgain() {
            this.polling = setInterval(function() {
                if (this.isComplete) {
                    this.fullscreenLoading = false
                    clearInterval(this.polling)
                    this.$message.success("更新が完了しました")
                } else {
                    this.getData()
                }
            }.bind(this), 1500)
                
        },

        getData: async function() {
          // DynamoDBからデータを取得
          let reportPromise = this.$store.dispatch('getReportData').catch(e => this.$message.error(e.message));
          let realtimePromise = this.$store.dispatch('getRealtimeData').catch(e => this.$message.error(e.message));
          await reportPromise
          await realtimePromise
        }
    }
}
</script>

<style>

.configuration{
    display: flex;
    flex-direction: column;
}

h1 {
    width: 100%;
    font-size: 20px; 
}

ul {
    list-style: none;
    padding: 0;
    max-height: 400px;
    overflow: auto;
}

ul li{
    margin-bottom: 10px;
}

.el-card{
    width: 100%;
    max-width: 800px;
    margin: auto;
}

.update-configuration-button{
    text-align: right;
}

.stream-name {
    padding: 20px 0;
}

</style>